import { HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { ToastService } from '../../../core/services/toast.service';
import { PdfPreviewService } from '../../../shared/services/pdf-preview.service';
import { BestellungenService } from './bestellungen.service';

@Injectable({
  providedIn: 'root',
})
export class BestellungPdfService {
  private readonly bestellungenService =
    inject(BestellungenService);

  private readonly pdfPreviewService =
    inject(PdfPreviewService);

  private readonly toastService =
    inject(ToastService);

  openBestelluebersicht(
    bestellungId: string
  ): void {
    this.bestellungenService
      .getBestellungBericht(bestellungId)
      .subscribe({
        next: (response) => {
          const pdf = response.body;

          if (!pdf || pdf.size === 0) {
            this.toastService.warning(
              'Keine PDF-Daten vorhanden',
              'Für diese Bestellung konnte kein PDF-Bericht erstellt werden.'
            );
            return;
          }

          this.pdfPreviewService.open({
            title: 'Bestellübersicht',
            fileName:
              this.getFileName(response),
            blob: pdf,
          });
        },

        error: () => {
          this.toastService.error(
            'PDF konnte nicht geladen werden',
            'Bitte versuche es erneut.'
          );
        },
      });
  }

  private getFileName(
    response: HttpResponse<Blob>
  ): string {
    const contentDisposition =
      response.headers.get(
        'Content-Disposition'
      );

    if (!contentDisposition) {
      return 'Bestelluebersicht.pdf';
    }

    const utf8FileName =
      contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i
      )?.[1];

    if (utf8FileName) {
      try {
        return decodeURIComponent(
          utf8FileName
        );
      } catch {
        return utf8FileName;
      }
    }

    const fileName =
      contentDisposition.match(
        /filename="?([^";]+)"?/i
      )?.[1];

    return (
      fileName ??
      'Bestelluebersicht.pdf'
    );
  }
}